import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

const TextAreaFieldGroup = ({ name, placeholder, label, value, error, info, onChange }) => {
	return (
		<div className="form-group">
			<label
				htmlFor={name}
				className="pl-2"
				style={{color:'#9CA860'}}
			>
				{label ? label : null}
			</label>
			<textarea
				style={{height:150}}
				id={name}
				className={classnames("form-control", {
					"is-invalid": error
				})}
				placeholder={placeholder}
				name={name}
				value={value}
				onChange={onChange}
			/>
			{info && <small className="form-text text-muted">{info}</small>}
			{error && <div className="invalid-feedback" id={name+"_error"}>{error}</div>}
		</div>
	);
};

TextAreaFieldGroup.propTypes = {
	name: PropTypes.string.isRequired,
	placeholder: PropTypes.string,
	info: PropTypes.string,
	error: PropTypes.string,
	onChange: PropTypes.func.isRequired
};

export default TextAreaFieldGroup;
